"use client"

import type React from "react"

import { usePathname } from "next/navigation"
import { useAuth } from "@/components/auth-provider"
import { AppSidebar } from "@/components/app-sidebar"
import { OrganizationSidebar } from "@/components/organization-sidebar"
import { ClientSidebar } from "@/components/client-sidebar"
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"

interface ConditionalSidebarLayoutProps {
  children: React.ReactNode
}

export function ConditionalSidebarLayout({ children }: ConditionalSidebarLayoutProps) {
  const pathname = usePathname()
  const { user } = useAuth()

  const shouldShowSidebar = !pathname.startsWith("/login")

  if (!shouldShowSidebar) {
    return <>{children}</>
  }

  const getSidebarComponent = () => {
    if (!user) return AppSidebar

    switch (user.role) {
      case "organization":
        return OrganizationSidebar
      case "client":
        return ClientSidebar
      case "internal":
      default:
        return AppSidebar
    }
  }

  const SidebarComponent = getSidebarComponent()

  return (
    <SidebarProvider defaultOpen={false}>
      <SidebarComponent />
      <SidebarInset>{children}</SidebarInset>
    </SidebarProvider>
  )
}
